import { render, staticRenderFns } from "./OverviewPanel.vue?vue&type=template&id=25581c9f&scoped=true&"
import script from "./OverviewPanel.vue?vue&type=script&lang=js&"
export * from "./OverviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPanel.vue?vue&type=style&index=0&id=25581c9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25581c9f",
  null
  
)

/* custom blocks */
import block0 from "./OverviewPanel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports